import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { Operation } from './../models/operation';

@Injectable()
export class OperationService {

  constructor(
    private http: HttpClient
  ) { }

  retrieveAll() {
    return this.http.get(`${environment.apiUrl}/operation/`).pipe(
      map((resp: any) => resp.data.map((operationData: any) => new Operation().hydrateWith(operationData)))
    );
  }

}
